import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { AccountIdSchema } from '../models.accounts';
import { GenericConnectionId, QueryBooleanSchema, URLParamsSchema } from '../models.generic';

extendZodWithOpenApi(z);

// Parity with other `*.http.ts` modules (keeps docs generation consistent)
// biome-ignore lint/correctness/noUnusedVariables: intentional
const c = initContract();

/**
 * Query params for connection-scoped "identity browsing" (admin/debug style).
 *
 * @remarks
 * `accountId` is an optional pin used for validation (future: account-wide browsing).
 */
export type IdentityBrowseQueryParams = z.infer<typeof IdentityBrowseQueryParamsSchema>;
export const IdentityBrowseQueryParamsSchema = z.object({
  connectionId: GenericConnectionId.describe('Scope results to a single connection'),
  accountId: AccountIdSchema.optional().describe(
    'Optional pin to an account. If provided, must match the account of the connection (future: account-wide browsing).'
  ),
  search: z
    .string()
    .optional()
    .describe('Search term for debugging (may be slow at scale without a dedicated index).'),
  claimed: QueryBooleanSchema.optional().describe(
    'Filter by whether the identity has been claimed by a TIC user'
  ),
  syncToTimely: QueryBooleanSchema.optional().describe(
    'Filter by whether the identity is allowed to sync to Timely'
  ),
  hasTimelyUserId: QueryBooleanSchema.optional().describe(
    'Filter by whether the identity has a Timely user mapping'
  ),
  page: URLParamsSchema.page.min(1).default(1).describe('Page number for pagination'),
  limit: URLParamsSchema.limit
    .min(1)
    .max(200)
    .default(50)
    .describe('Maximum number of results to return per page (1-200, default: 50)'),
});
